import * as Types from '@trello/graphql/generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"UpdateCardDueComplete"}}
export type UpdateCardDueCompleteMutationVariables = Types.Exact<{
  cardId: Types.Scalars['ID'];
  dueComplete: Types.Scalars['Boolean'];
  traceId: Types.Scalars['String'];
}>;


export type UpdateCardDueCompleteMutation = (
  { __typename: 'Mutation' }
  & { updateCardDueComplete?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'dueComplete'>
  )> }
);


export const UpdateCardDueCompleteDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCardDueComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dueComplete"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCardDueComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cardId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"dueComplete"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dueComplete"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dueComplete"}}]}}]}}]};
export type UpdateCardDueCompleteMutationFn = Apollo.MutationFunction<UpdateCardDueCompleteMutation, UpdateCardDueCompleteMutationVariables>;

/**
 * __useUpdateCardDueCompleteMutation__
 *
 * To run a mutation, you first call `useUpdateCardDueCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCardDueCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCardDueCompleteMutation, { data, loading, error }] = useUpdateCardDueCompleteMutation({
 *   variables: {
 *      cardId: // value for 'cardId'
 *      dueComplete: // value for 'dueComplete'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useUpdateCardDueCompleteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCardDueCompleteMutation, UpdateCardDueCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCardDueCompleteMutation, UpdateCardDueCompleteMutationVariables>(UpdateCardDueCompleteDocument, options);
      }
export type UpdateCardDueCompleteMutationHookResult = ReturnType<typeof useUpdateCardDueCompleteMutation>;
export type UpdateCardDueCompleteMutationResult = Apollo.MutationResult<UpdateCardDueCompleteMutation>;
export type UpdateCardDueCompleteMutationOptions = Apollo.BaseMutationOptions<UpdateCardDueCompleteMutation, UpdateCardDueCompleteMutationVariables>;